import { render, staticRenderFns } from "./topBanner.vue?vue&type=template&id=30523032&scoped=true"
import script from "./topBanner.vue?vue&type=script&lang=js"
export * from "./topBanner.vue?vue&type=script&lang=js"
import style0 from "./topBanner.vue?vue&type=style&index=0&id=30523032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30523032",
  null
  
)

export default component.exports